import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

const TokenTicker = () => {
  const tokens = [
    { name: "DOGE", change: "+4.2%", positive: true },
    { name: "SHIB", change: "-1.8%", positive: false },
    { name: "PEPE", change: "+12.6%", positive: true },
    { name: "WIF", change: "+8.1%", positive: true },
    { name: "FLOKI", change: "-3.2%", positive: false },
    { name: "BONK", change: "+22.4%", positive: true },
    { name: "MYRO", change: "-0.9%", positive: false },
    { name: "MEW", change: "+6.7%", positive: true },
    { name: "BOME", change: "+15.3%", positive: true },
    { name: "POPCAT", change: "+9.8%", positive: true },
  ];

  return (
    <section
      className="relative py-4 md:py-8 overflow-hidden"
      data-testid="token-ticker"
    >
      {/* Gradient fade edges */}
      <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-[#05050A] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-[#05050A] to-transparent z-10" />

      <Marquee
        speed={40}
        gradient={false}
        className="py-2 md:py-4"
      >
        {[...tokens, ...tokens].map((token, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.05 }}
            className="flex items-center gap-2 md:gap-3 mx-3 md:mx-8 px-4 md:px-6 py-2.5 md:py-3 rounded-lg md:rounded-xl glass ice-hover cursor-pointer"
          >
            <span className="font-mono font-bold text-white text-sm md:text-lg">
              {token.name}
            </span>
            <span
              className={`font-mono font-semibold text-sm md:text-lg ${
                token.positive ? "text-[#10B981]" : "text-[#EF4444]"
              }`}
            >
              {token.change}
            </span>
          </motion.div>
        ))}
      </Marquee>
    </section>
  );
};

export default TokenTicker;
